<template>
  <div class="card-modern">
         <form @submit.prevent="handleSubmit" class="space-y-6" novalidate>
      <!-- Dynamic Fields -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
                 <div 
           v-for="field in sortedFields" 
           :key="field.id"
           :class="[
             'animate-slide-up',
             field.type === 'textarea' || field.type === 'checkbox' || field.type === 'file' ? 'md:col-span-2' : ''
           ]"
         >
                                <!-- Text Input -->
           <div v-if="field.type === 'text'">
             <label :for="field.id" class="flex items-center text-sm font-medium text-gray-700 mb-2">
               <span v-html="field.label" class="field-label"></span>
               <span v-if="field.required">&nbsp;*</span>
               <button 
                 v-if="field.hasInfo" 
                 type="button"
                 @click="showInfo(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-blue-500 hover:text-blue-700 transition-colors"
                 title="Показати приклад"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
               
               <button 
                 v-if="field.hasInfo2" 
                 type="button"
                 @click="showInfo2(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-green-500 hover:text-green-700 transition-colors"
                 title="Показати приклад 2"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
             </label>
             <input
               :id="field.id"
               v-model="formData[field.id]"
               type="text"
               :placeholder="field.placeholder"
               :class="[
                 'form-input h-[50px]',
                 validationErrors[field.id] ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50' : ''
               ]"
               @input="field.mask ? handleMaskedInput($event, field) : clearValidationError(field.id)"
               @keydown="field.mask ? handleMaskedKeyDown($event, field) : null"
             />
              <div v-if="validationErrors[field.id]" class="mt-1 text-xs text-red-600 animate-pulse">
                {{ validationErrors[field.id] }}
              </div>
              <!-- Field Description -->
              <div v-if="field.description" class="mt-2 text-sm text-gray-600 field-description">
                <span v-html="field.description"></span>
              </div>
            </div>

                                <!-- Email Input -->
           <div v-else-if="field.type === 'email'">
             <label :for="field.id" class="flex items-center text-sm font-medium text-gray-700 mb-2">
               <span v-html="field.label" class="field-label"></span>
               <span v-if="field.required">&nbsp;*</span>
               <button 
                 v-if="field.hasInfo" 
                 type="button"
                 @click="showInfo(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-blue-500 hover:text-blue-700 transition-colors"
                 title="Показати приклад"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
               
               <button 
                 v-if="field.hasInfo2" 
                 type="button"
                 @click="showInfo2(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-green-500 hover:text-green-700 transition-colors"
                 title="Показати приклад 2"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
             </label>
             <input
               :id="field.id"
               v-model="formData[field.id]"
               type="email"
               :placeholder="field.placeholder"
               :class="[
                 'form-input h-[50px]',
                 validationErrors[field.id] ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50' : ''
               ]"
               @input="field.mask ? handleMaskedInput($event, field) : clearValidationError(field.id)"
               @keydown="field.mask ? handleMaskedKeyDown($event, field) : null"
             />
              <div v-if="validationErrors[field.id]" class="mt-1 text-xs text-red-600 animate-pulse">
                {{ validationErrors[field.id] }}
              </div>
              <!-- Field Description -->
              <div v-if="field.description" class="mt-2 text-sm text-gray-600 field-description">
                <span v-html="field.description"></span>
              </div>
            </div>

                                <!-- Phone Input -->
           <div v-else-if="field.type === 'phone'">
             <label :for="field.id" class="flex items-center text-sm font-medium text-gray-700 mb-2">
               <span v-html="field.label" class="field-label"></span>
               <span v-if="field.required">&nbsp;*</span>
               <button 
                 v-if="field.hasInfo" 
                 type="button"
                 @click="showInfo(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-blue-500 hover:text-blue-700 transition-colors"
                 title="Показати приклад"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
               
               <button 
                 v-if="field.hasInfo2" 
                 type="button"
                 @click="showInfo2(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-green-500 hover:text-green-700 transition-colors"
                 title="Показати приклад 2"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
             </label>
             <input
               :id="field.id"
               v-model="formData[field.id]"
               type="tel"
               :placeholder="field.placeholder"
               :class="[
                 'form-input h-[50px]',
                 validationErrors[field.id] ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50' : ''
               ]"
               @input="field.mask ? handleMaskedInput($event, field) : clearValidationError(field.id)"
               @keydown="field.mask ? handleMaskedKeyDown($event, field) : null"
             />
              <div v-if="validationErrors[field.id]" class="mt-1 text-xs text-red-600 animate-pulse">
                {{ validationErrors[field.id] }}
              </div>
              <!-- Field Description -->
              <div v-if="field.description" class="mt-2 text-sm text-gray-600 field-description">
                <span v-html="field.description"></span>
              </div>
            </div>

                                <!-- Number Input -->
           <div v-else-if="field.type === 'number'">
             <label :for="field.id" class="flex items-center text-sm font-medium text-gray-700 mb-2">
               <span v-html="field.label" class="field-label"></span>
               <span v-if="field.required">&nbsp;*</span>
               <button 
                 v-if="field.hasInfo" 
                 type="button"
                 @click="showInfo(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-blue-500 hover:text-blue-700 transition-colors"
                 title="Показати приклад"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
               
               <button 
                 v-if="field.hasInfo2" 
                 type="button"
                 @click="showInfo2(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-green-500 hover:text-green-700 transition-colors"
                 title="Показати приклад 2"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
             </label>
             <input
               :id="field.id"
               v-model="formData[field.id]"
               :type="field.mask ? 'text' : 'number'"
               :placeholder="field.placeholder"
               :class="[
                 'form-input h-[50px]',
                 validationErrors[field.id] ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50' : ''
               ]"
               @input="field.mask ? handleMaskedInput($event, field) : clearValidationError(field.id)"
               @keydown="field.mask ? handleMaskedKeyDown($event, field) : null"
             />
              <div v-if="validationErrors[field.id]" class="mt-1 text-xs text-red-600 animate-pulse">
                {{ validationErrors[field.id] }}
              </div>
              <!-- Field Description -->
              <div v-if="field.description" class="mt-2 text-sm text-gray-600 field-description">
                <span v-html="field.description"></span>
              </div>
            </div>

                     <!-- Select Input -->
           <div v-else-if="field.type === 'select'">
             <label :for="field.id" class="flex items-center text-sm font-medium text-gray-700 mb-2">
               <span v-html="field.label" class="field-label"></span>
               <span v-if="field.required">&nbsp;*</span>
               <button 
                 v-if="field.hasInfo" 
                 type="button"
                 @click="showInfo(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-blue-500 hover:text-blue-700 transition-colors"
                 title="Показати приклад"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
               
               <button 
                 v-if="field.hasInfo2" 
                 type="button"
                 @click="showInfo2(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-green-500 hover:text-green-700 transition-colors"
                 title="Показати приклад 2"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
             </label>
             
                           <!-- Main select field -->
              <select
                :id="field.id"
                v-model="formData[field.id]"
                :class="[
                  'form-select h-[50px]',
                  validationErrors[field.id] ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50' : ''
                ]"
                @change="clearValidationError(field.id)"
                autocomplete="off"
              >
               <option value="" disabled>{{ field.placeholder || 'Оберіть опцію' }}</option>
               <option 
                 v-for="option in field.options" 
                 :key="option" 
                 :value="option"
               >
                 {{ option }}
               </option>
             </select>
             
             <!-- Duplicate select fields -->
             <div v-if="field.allowDuplicate && duplicateFields[field.id]" class="mt-3 space-y-3">
               <div 
                 v-for="(duplicate, index) in duplicateFields[field.id]" 
                 :key="duplicate.id"
                 class="flex items-center gap-3"
               >
                 <select
                   :id="duplicate.id"
                   v-model="duplicate.value"
                   class="form-select h-[50px] flex-1"
                   autocomplete="off"
                 >
                   <option value="" disabled>{{ field.placeholder || 'Оберіть опцію' }}</option>
                   <option 
                     v-for="option in field.options" 
                     :key="option" 
                     :value="option"
                   >
                     {{ option }}
                   </option>
                 </select>
                 <button
                   type="button"
                   @click="removeDuplicateField(field.id, index)"
                   class="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-md transition-colors"
                   title="Видалити"
                 >
                   <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                   </svg>
                 </button>
               </div>
             </div>
             
            <div v-if="validationErrors[field.id]" class="mt-1 text-xs text-red-600 animate-pulse">
              {{ validationErrors[field.id] }}
            </div>
            
            <!-- Add more button -->
            <div v-if="field.allowDuplicate" class="mt-3">
              <button
                type="button"
                @click="addDuplicateField(field.id)"
                class="inline-flex items-center gap-1 px-2 py-1 text-xs text-blue-600 hover:text-blue-800 transition-colors"
                title="Додати ще"
              >
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                Додати ще
              </button>
            </div>
            <!-- Field Description -->
            <div v-if="field.description" class="mt-2 text-sm text-gray-600 field-description">
              <span v-html="field.description"></span>
            </div>
          </div>

          <!-- Checkbox Input -->
          <div v-else-if="field.type === 'checkbox'">
            <div class="flex items-center">
                             <input
                 :id="field.id"
                 v-model="formData[field.id]"
                 type="checkbox"
                 :class="[
                   'h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded shrink-0',
                   validationErrors[field.id] ? 'border-red-500 focus:ring-red-500' : ''
                 ]"
                 @change="clearValidationError(field.id)"
               />
              <label :for="field.id" class="ml-2 block text-sm text-gray-700">
                <span v-html="field.label" class="field-label"></span>
                <span v-if="field.required">&nbsp;*</span>
                <button 
                  v-if="field.hasInfo" 
                  type="button"
                  @click="showInfo(field.id)"
                  class="ml-2 inline-flex items-center justify-center w-5 h-5 text-blue-500 hover:text-blue-700 transition-colors"
                  title="Показати приклад"
                >
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                  </svg>
                </button>
                
                <button 
                  v-if="field.hasInfo2" 
                  type="button"
                  @click="showInfo2(field.id)"
                  class="ml-2 inline-flex items-center justify-center w-5 h-5 text-green-500 hover:text-green-700 transition-colors"
                  title="Показати приклад 2"
                >
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                  </svg>
                </button>
              </label>
            </div>
                                                   <div v-if="validationErrors[field.id]" class="mt-1 ml-6 text-xs text-red-600 animate-pulse">
                {{ validationErrors[field.id] }}
              </div>
              <!-- Field Description -->
              <div v-if="field.description" class="mt-2 ml-6 text-sm text-gray-600 field-description">
                <span v-html="field.description"></span>
              </div>
          </div>

                     <!-- File Upload -->
           <div v-else-if="field.type === 'file'">
             <label :for="field.id" class="flex items-center text-sm font-medium text-gray-700 mb-2">
               <span v-html="field.label" class="field-label"></span>
               <span v-if="field.required">&nbsp;*</span>
               <button 
                 v-if="field.hasInfo" 
                 type="button"
                 @click="showInfo(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-blue-500 hover:text-blue-700 transition-colors"
                 title="Показати приклад"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
               
               <button 
                 v-if="field.hasInfo2" 
                 type="button"
                 @click="showInfo2(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-green-500 hover:text-green-700 transition-colors"
                 title="Показати приклад 2"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
             </label>
             <div class="space-y-2">
               <input
                 :id="field.id"
                 type="file"
                 @change="handleFileChange"
                 :class="[
                   'form-input h-[50px]',
                   validationErrors[field.id] ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50' : ''
                 ]"
                 :accept="getFileAcceptTypes()"
               />
               <div v-if="selectedFile" class="text-sm text-gray-600">
                 <span class="font-medium">Вибрано:</span> {{ selectedFile.name }}
                 <span class="text-red-500">({{ formatFileSize(selectedFile.size) }})</span>
               </div>
             </div>
                         <div v-if="validationErrors[field.id]" class="mt-1 text-xs text-red-600 animate-pulse">
               {{ validationErrors[field.id] }}
             </div>
             <!-- Field Description -->
             <div v-if="field.description" class="mt-2 text-sm text-gray-600 field-description">
               <span v-html="field.description"></span>
             </div>
          </div>

                     <!-- Textarea Input -->
           <div v-else-if="field.type === 'textarea'">
             <label :for="field.id" class="flex items-center text-sm font-medium text-gray-700 mb-2">
               <span v-html="field.label" class="field-label"></span>
               <span v-if="field.required">&nbsp;*</span>
               <button 
                 v-if="field.hasInfo" 
                 type="button"
                 @click="showInfo(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-blue-500 hover:text-blue-700 transition-colors"
                 title="Показати приклад"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
               
               <button 
                 v-if="field.hasInfo2" 
                 type="button"
                 @click="showInfo2(field.id)"
                 class="ml-2 inline-flex items-center justify-center w-5 h-5 text-green-500 hover:text-green-700 transition-colors"
                 title="Показати приклад 2"
               >
                 <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                   <circle cx="12" cy="12" r="10"/>
                   <path d="M12 16v-4"/>
                   <path d="M12 8h.01"/>
                 </svg>
               </button>
             </label>
             <textarea
               :id="field.id"
               v-model="formData[field.id]"
               :placeholder="field.placeholder"
               rows="4"
               :class="[
                 'form-input',
                 validationErrors[field.id] ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50' : ''
               ]"
               @input="field.mask ? handleMaskedInput($event, field) : clearValidationError(field.id)"
               @keydown="field.mask ? handleMaskedKeyDown($event, field) : null"
             ></textarea>
              <div v-if="validationErrors[field.id]" class="mt-1 text-xs text-red-600 animate-pulse">
                {{ validationErrors[field.id] }}
              </div>
              <!-- Field Description -->
              <div v-if="field.description" class="mt-2 text-sm text-gray-600 field-description">
                <span v-html="field.description"></span>
              </div>
            </div>
        </div>
      </div>

             <!-- Submit Button -->
       <div class="pt-4 flex justify-center">
         <button
           type="submit"
           :disabled="loading"
           class="w-full md:w-auto md:px-8 btn-hero disabled:opacity-50 disabled:cursor-not-allowed"
         >
            <span v-if="loading" class="flex items-center justify-center">
              <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Відправлення...
            </span>
          <span v-else class="flex items-center gap-2 justify-center">
            <svg class="w-5 h-5 rotate-45 -mt-1 opacity-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
            </svg>
            Відправити форму
          </span>
        </button>
      </div>
    </form>

    <!-- Success Message -->
    <div 
      v-if="showSuccess"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="bg-white rounded-lg p-8 max-w-md mx-4 text-center animate-scale-in">
        <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
                            <h3 class="text-lg font-semibold text-gray-900 mb-2">Дякуємо!</h3>
                    <p class="text-gray-600 mb-6">
                      Ваша форма успішно відправлена. Ми зв'яжемося з вами найближчим часом.
                    </p>
                    <button 
                      @click="closeSuccessModal"
                      class="btn-hero"
                    >
                      Закрити
                    </button>
      </div>
    </div>

    <!-- Duplicate Warning Message -->
    <div 
      v-if="showDuplicatePopup"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="bg-white rounded-lg p-8 max-w-md mx-4 text-center animate-scale-in">
        <div class="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">Значення вже зареєстровано</h3>
        <div class="text-gray-600 mb-6 text-left">
          <p class="mb-2">В базі даних вже є підтверджена заявка з таким значенням:</p>
          <div class="bg-gray-50 p-3 rounded-lg text-sm">
            <p><strong>Поле:</strong> {{ duplicateInfo?.fieldLabel }}</p>
            <p><strong>Значення:</strong> {{ duplicateInfo?.matchedValue }}</p>
            <p><strong>Дата створення:</strong> {{ duplicateCreatedAt }}</p>
          </div>
          <p class="mt-3 text-red-600 font-medium">Заявка не буде відправлена.</p>
        </div>
        <button 
          @click="closeDuplicateModal"
          class="btn-hero bg-orange-600 hover:bg-orange-700"
        >
          Зрозуміло
        </button>
      </div>
    </div>

    <!-- Info Popup -->
    <div 
      v-if="showInfoPopup"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      @click="closeInfoPopup"
    >
      <div class="relative w-full h-full max-w-none animate-scale-in" @click.stop>
        <button 
          @click="closeInfoPopup"
          class="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors duration-200 z-10 bg-black bg-opacity-70 hover:bg-opacity-90 opacity-70 rounded-full p-3"
        >
          <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
        
        <div class="flex items-center justify-center w-full h-full">
          <img 
            src="/example.png" 
            alt="Приклад заповнення поля" 
            class="max-w-full max-h-full w-auto h-auto object-contain rounded-lg"
          />
        </div>
      </div>
    </div>

    <!-- Info2 Popup -->
    <div 
      v-if="showInfo2Popup"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      @click="closeInfo2Popup"
    >
      <div class="relative w-full h-full max-w-none animate-scale-in" @click.stop>
        <button 
          @click="closeInfo2Popup"
          class="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors duration-200 z-10 bg-black bg-opacity-70 hover:bg-opacity-90 opacity-70 rounded-full p-3"
        >
          <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
        
        <div class="flex items-center justify-center w-full h-full">
          <img 
            src="/example2.jpg" 
            alt="Приклад заповнення поля 2" 
            class="max-w-full max-h-full w-auto h-auto object-contain rounded-lg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useFormsStore } from '@/stores/forms'
import type { Form } from '@/stores/forms'

interface Props {
  form: Form
}

const props = defineProps<Props>()
const formsStore = useFormsStore()

const formData = ref<Record<string, any>>({})
const selectedFile = ref<File | null>(null)
const loading = ref(false)
const showSuccess = ref(false)
const showDuplicatePopup = ref(false)
const showInfoPopup = ref(false)
const showInfo2Popup = ref(false)

// Duplicate fields data
const duplicateFields = ref<Record<string, any[]>>({})

// Functions for duplicate fields
const addDuplicateField = (fieldId: string) => {
  if (!duplicateFields.value[fieldId]) {
    duplicateFields.value[fieldId] = []
  }
  duplicateFields.value[fieldId].push({
    id: `${fieldId}_duplicate_${Date.now()}`,
    value: ''
  })
}

const removeDuplicateField = (fieldId: string, duplicateIndex: number) => {
  if (duplicateFields.value[fieldId]) {
    duplicateFields.value[fieldId].splice(duplicateIndex, 1)
  }
}

const currentInfoField = ref<string | null>(null)
const currentInfo2Field = ref<string | null>(null)
const validationErrors = ref<Record<string, string>>({})
const duplicateInfo = ref<any>(null)

const duplicateCreatedAt = computed(() => {
  if (!duplicateInfo.value?.createdAt) return ''
  return new Date(duplicateInfo.value.createdAt).toLocaleDateString('uk-UA')
})

// Sort fields by order
const sortedFields = computed(() => {
  return [...props.form.fields].sort((a, b) => a.order - b.order)
})

// Initialize form data
onMounted(() => {
  props.form.fields.forEach(field => {
    if (field.type === 'checkbox') {
      formData.value[field.id] = false
    } else if (field.type === 'select') {
      // For select fields, set empty value to show placeholder
      formData.value[field.id] = ''
    } else {
      formData.value[field.id] = ''
    }
    
    // Initialize hasInfo if not present
    if (field.hasInfo === undefined) {
      field.hasInfo = false
    }
    
    // Initialize hasInfo2 if not present
    if (field.hasInfo2 === undefined) {
      field.hasInfo2 = false
    }
    
    // Initialize mask if not present
    if (field.mask === undefined) {
      field.mask = ''
    }
    
    // Initialize allowDuplicate if not present
    if (field.allowDuplicate === undefined) {
      field.allowDuplicate = false
    }
  })
})


// Handle file selection
const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.files && target.files[0]) {
    selectedFile.value = target.files[0]
    // Clear validation error for file field
    const fieldId = target.id
    if (validationErrors.value[fieldId]) {
      clearValidationError(fieldId)
    }
  }
}

// Get file accept types for input
const getFileAcceptTypes = () => {
  return '.jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv'
}

// Format file size for display
const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

// Show info popup
const showInfo = (fieldId: string) => {
  currentInfoField.value = fieldId
  showInfoPopup.value = true
}

// Close info popup
const closeInfoPopup = () => {
  showInfoPopup.value = false
  currentInfoField.value = null
}

// Show info2 popup
const showInfo2 = (fieldId: string) => {
  currentInfo2Field.value = fieldId
  showInfo2Popup.value = true
}

// Close info2 popup
const closeInfo2Popup = () => {
  showInfo2Popup.value = false
  currentInfo2Field.value = null
}

// Close duplicate modal
const closeDuplicateModal = () => {
  showDuplicatePopup.value = false
  duplicateInfo.value = null
}

// Close success modal and reset form completely
const closeSuccessModal = () => {
  showSuccess.value = false
  
  // Reset form data
  props.form.fields.forEach(field => {
    if (field.type === 'checkbox') {
      formData.value[field.id] = false
    } else if (field.type === 'select') {
      formData.value[field.id] = ''
    } else {
      formData.value[field.id] = ''
    }
  })
  
  // Reset duplicate fields
  duplicateFields.value = {}
  
  // Reset file
  selectedFile.value = null
  
  // Clear all file inputs
  const fileInputs = document.querySelectorAll('input[type="file"]')
  fileInputs.forEach((input) => {
    if (input instanceof HTMLInputElement) {
      input.value = ''
    }
  })
  
  // Clear validation errors
  validationErrors.value = {}
  
  // Close info popup if open
  if (showInfoPopup.value) {
    closeInfoPopup()
  }
  
  // Close info2 popup if open
  if (showInfo2Popup.value) {
    closeInfo2Popup()
  }
}

// Validate form fields
const validateForm = () => {
  validationErrors.value = {}
  let isValid = true
  
  props.form.fields.forEach(field => {
    if (field.required) {
      const value = formData.value[field.id]
      
      if (field.type === 'checkbox') {
        if (!value) {
          validationErrors.value[field.id] = 'Поле є обов\'язковим'
          isValid = false
        }
      } else if (field.type === 'file') {
        if (!selectedFile.value) {
          validationErrors.value[field.id] = 'Поле є обов\'язковим'
          isValid = false
        }
      } else {
        if (!value || (typeof value === 'string' && value.trim() === '')) {
          validationErrors.value[field.id] = 'Поле є обов\'язковим'
          isValid = false
        }
      }
    }
  })
  
  return isValid
}

// Clear validation error for specific field
const clearValidationError = (fieldId: string) => {
  if (validationErrors.value[fieldId]) {
    delete validationErrors.value[fieldId]
  }
}

// Handle backspace for masked fields
const handleMaskedKeyDown = (event: KeyboardEvent, field: any) => {
  if (!field.mask) return
  
  if (event.key === 'Backspace') {
    const target = event.target as HTMLInputElement
    const cursorPos = target.selectionStart || 0
    const value = target.value
    
    // If cursor is right after a fixed character, move it back one more position
    if (cursorPos > 0) {
      const charBefore = value[cursorPos - 1]
      if (charBefore && charBefore !== 'x' && charBefore !== 'a') {
        // It's a fixed character, move cursor back
        setTimeout(() => {
          target.setSelectionRange(cursorPos - 1, cursorPos - 1)
        }, 0)
      }
    }
  }
  
  // Prevent typing characters that are not allowed in mask
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End']
  
  // Check if mask allows letters (contains 'a')
  const allowsLetters = field.mask.includes('a')
  // Check if mask allows digits (contains 'x')
  const allowsDigits = field.mask.includes('x')
  
  if (allowsLetters && allowsDigits) {
    // Allow both letters and digits
    if (!/^[a-zA-Z0-9]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault()
    }
  } else if (allowsLetters) {
    // Allow only letters
    if (!/^[a-zA-Z]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault()
    }
  } else if (allowsDigits) {
    // Allow only digits
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault()
    }
  }
}

// Simple mask function - only allow digits and apply basic formatting
const handleMaskedInput = (event: Event, field: any) => {
  if (!field.mask) {
    clearValidationError(field.id)
    return
  }
  
  const target = event.target as HTMLInputElement
  let value = target.value
  
  // Get only user input (remove all fixed characters from mask)
  let userInput = value
  
  // For +38 mask, remove the +38 part to get only user digits
  if (field.mask.includes('+38')) {
    userInput = value.replace(/^\+38\s*/, '')
  }
  // For UA mask, remove the UA part to get only user digits  
  else if (field.mask.includes('UA')) {
    userInput = value.replace(/^UA/, '')
  }
  
  // Extract digits and letters from user input only
  const digits = userInput.replace(/\D/g, '')
  const letters = userInput.replace(/[^a-zA-Z]/g, '')
  
  // If no user input, return empty string
  if (digits.length === 0 && letters.length === 0) {
    target.value = ''
    formData.value[field.id] = ''
    clearValidationError(field.id)
    return
  }
  
  // Apply mask from admin panel
  let formatted = ''
  let digitIndex = 0
  let letterIndex = 0
  
  for (let i = 0; i < field.mask.length; i++) {
    if (field.mask[i] === 'x') {
      // Place for digit
      if (digitIndex < digits.length) {
        formatted += digits[digitIndex]
        digitIndex++
      } else {
        // No more digits, stop here
        break
      }
    } else if (field.mask[i] === 'a') {
      // Place for letter
      if (letterIndex < letters.length) {
        formatted += letters[letterIndex]
        letterIndex++
      } else {
        // No more letters, stop here
        break
      }
    } else {
      // Fixed character from mask (space, dash, letters, etc.)
      formatted += field.mask[i]
    }
  }
  
  // Update values
  target.value = formatted
  formData.value[field.id] = formatted
  clearValidationError(field.id)
}





// Handle form submission
const handleSubmit = async () => {
  // Clear previous validation errors
  validationErrors.value = {}
  
  // Validate form before submission
  if (!validateForm()) {
    // Small delay to make validation errors more visible
    await new Promise(resolve => setTimeout(resolve, 100))
    return
  }
  
  try {
    loading.value = true
    
    // Prepare form data with duplicate fields (exclude checkboxes)
    const submissionData: Record<string, any> = {}
    
    // Only include non-checkbox fields
    Object.keys(formData.value).forEach(fieldId => {
      const field = props.form.fields.find(f => f.id === fieldId)
      if (field && field.type !== 'checkbox') {
        submissionData[fieldId] = formData.value[fieldId]
      }
    })
    
    // Add duplicate fields data
    Object.keys(duplicateFields.value).forEach(fieldId => {
      const duplicates = duplicateFields.value[fieldId]
      if (duplicates && duplicates.length > 0) {
        // Create array of values from duplicates
        const duplicateValues = duplicates
          .map(dup => dup.value)
          .filter(value => value !== '') // Only include non-empty values
        
        if (duplicateValues.length > 0) {
          // Combine main field value with duplicates
          const mainValue = submissionData[fieldId] || ''
          const allValues = [mainValue, ...duplicateValues].filter(value => value !== '')
          submissionData[fieldId] = allValues.join(', ')
        }
      }
    })
    
    // Check for duplicates before submission
    const duplicateCheck = await formsStore.checkDuplicate(props.form.id, submissionData)
    
    if (!duplicateCheck.success) {
      alert('Помилка перевірки дублікатів: ' + duplicateCheck.error)
      loading.value = false
      return
    }
    
    if (duplicateCheck.isDuplicate) {
      const duplicate = duplicateCheck.duplicate
      duplicateInfo.value = duplicate
      showDuplicatePopup.value = true
      loading.value = false
      return
    }
    
    const result = await formsStore.submitForm(
      props.form.id,
      submissionData,
      selectedFile.value || undefined
    )
    
    if (!result.success) {
      if (result.isDuplicate && result.duplicate) {
        duplicateInfo.value = result.duplicate
        showDuplicatePopup.value = true
        return
      }
      alert('Помилка відправлення форми: ' + result.error)
      return
    }

    showSuccess.value = true
      
      // Reset form
      props.form.fields.forEach(field => {
        if (field.type === 'checkbox') {
          formData.value[field.id] = false
        } else if (field.type === 'select') {
          // For select fields, reset to empty value to show placeholder
          formData.value[field.id] = ''
        } else {
          formData.value[field.id] = ''
        }
      })
      
      // Reset duplicate fields
      duplicateFields.value = {}
      
      // Reset file input
      selectedFile.value = null
      
      // Clear file input element
      const fileInputs = document.querySelectorAll('input[type="file"]')
      fileInputs.forEach((input) => {
        if (input instanceof HTMLInputElement) {
          input.value = ''
        }
      })
      
      // Also clear any file input by ID if we know the field ID
      props.form.fields.forEach(field => {
        if (field.type === 'file') {
          const fileInput = document.getElementById(field.id) as HTMLInputElement
          if (fileInput) {
            fileInput.value = ''
          }
        }
      })
      
      // Close info popup if open
      if (showInfoPopup.value) {
        closeInfoPopup()
      }
      
      // Close info2 popup if open
      if (showInfo2Popup.value) {
        closeInfo2Popup()
      }
      
      // Clear validation errors on success
      validationErrors.value = {}
  } catch (error) {
    console.error('Form submission error:', error)
    alert('Сталася помилка під час відправлення форми.')
  } finally {
    loading.value = false
    
    // Close info popup if open
    if (showInfoPopup.value) {
      closeInfoPopup()
    }
    
    // Close info2 popup if open
    if (showInfo2Popup.value) {
      closeInfo2Popup()
    }
  }
}
</script>

<style scoped>
.field-label :deep(a) {
  color: #3B82F6;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.field-label :deep(a:hover) {
  color: #1D4ED8;
  text-decoration: underline;
}

.field-description :deep(a) {
  color: #3B82F6;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.field-description :deep(a:hover) {
  color: #1D4ED8;
  text-decoration: underline;
}
</style>
